module.exports = __webpack_public_path__ + "img/17.f0e7fe3a.jpg";